// <auto-generated>
// This file is automatically generated from DSL.
// Do not modify this file directly. Changes will be overwritten.
// Generated: 2026-02-28T16:35:54.812Z
// </auto-generated>

import { lazy, Suspense } from 'react';

const ApprovalDelegationListView = lazy(() => import('@/workflow/ApprovalDelegationListView').then(m => ({ default: m.ApprovalDelegationListView })));
const ApprovalDelegationDetailView = lazy(() => import('@/workflow/ApprovalDelegationDetailView').then(m => ({ default: m.ApprovalDelegationDetailView })));
const ApprovalPolicyListView = lazy(() => import('@/workflow/ApprovalPolicyListView').then(m => ({ default: m.ApprovalPolicyListView })));
const ApprovalPolicyDetailView = lazy(() => import('@/workflow/ApprovalPolicyDetailView').then(m => ({ default: m.ApprovalPolicyDetailView })));
const ApprovalRequestListView = lazy(() => import('@/workflow/ApprovalRequestListView').then(m => ({ default: m.ApprovalRequestListView })));
const ApprovalRequestDetailView = lazy(() => import('@/workflow/ApprovalRequestDetailView').then(m => ({ default: m.ApprovalRequestDetailView })));

/**
 * Workflow Module Routes
 */
export const workflowRoutes = [
{ path: '/workflow/approvaldelegations',
element: <Suspense><ApprovalDelegationListView /></Suspense> },
{ path: '/workflow/approvaldelegations/:id',
element: <Suspense><ApprovalDelegationDetailView /></Suspense> },
{ path: '/workflow/approvalpolicies',
element: <Suspense><ApprovalPolicyListView /></Suspense> },
{ path: '/workflow/approvalpolicies/:id',
element: <Suspense><ApprovalPolicyDetailView /></Suspense> },
{ path: '/workflow/approvalrequests',
element: <Suspense><ApprovalRequestListView /></Suspense> },
{ path: '/workflow/approvalrequests/:id',
element: <Suspense><ApprovalRequestDetailView /></Suspense> }
];
